interface IRequestIgnoreValidation extends ng.IRequestShortcutConfig{
	ignoreBEValidation: boolean;
}

module finadai.services {
  export class NegotiationsService {
    paymentTypes: Array<models.PaymentType>;
    static instanceName = 'negotiationsService';
    constructor(private proxifier, private $http: ng.IHttpService, private $q: ng.IQService, private $filter){
      this.paymentTypes = null;
    }
    getPaymentTypes(){
      var defer = this.$q.defer();
      if(this.paymentTypes != null){
        defer.resolve(this.paymentTypes);
      }
      else{
        this.$http.get([this.proxifier(), 'finadai', 'payment_types'].join('/')).then((response: ng.IHttpPromiseCallbackArg<models.http.responses.Records<models.PaymentType>>) => {
          this.paymentTypes = response.data.data;
          defer.resolve(this.paymentTypes);
        });
      }
      return defer.promise;
    }
    getAvailablePaymentTypes(data) {
      return this.$http.post([this.proxifier(), 'finadai', 'payment_types', 'get'].join('/'), data);
    }
    get(id?, filters?){
      if(angular.isUndefined(id) || id == null){
        filters.gtd_created_at = this.$filter('date')(filters.gtd_created_at, 'yyyy-MM-dd');
        filters.ltd_created_at = this.$filter('date')(filters.ltd_created_at, 'yyyy-MM-dd');
        return this.$http.get([this.proxifier(), 'finadai', 'negotiations'].join('/'), { params: filters });
      }
      return this.$http.get([this.proxifier(), 'finadai', 'negotiations', id].join('/'), { params: { with: 'credits,payment_type,customer,granter,meta' } });
    }
    getCredit(id){
      return this.$http.get([this.proxifier(), 'finadai', 'credits', id].join('/'), { params: { with: 'customer' }});
    }
    getCredits(params){
      return this.$http.get([this.proxifier(), 'finadai', 'credits'].join('/'), { params: params});
    }
    getCoAcredits(loan_id, client_id): ng.IHttpPromise<models.http.responses.Record<models.http.responses.CoAccredits>>{
      return this.$http.post([this.proxifier(), 'finadai', 'credits', 'co_accredits'].join('/'), {client_id: client_id, loan_id: loan_id});
    }
    saveCredit(id, data): ng.IHttpPromise<models.http.responses.Record<models.Credit>>{
      return this.$http.put([this.proxifier(), 'finadai', 'credits', id].join('/'), data);
    }
    cancelNegotiation(data): ng.IHttpPromise<models.http.responses.Record<models.Negotiation>>{
        return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'cancel_negotiation'].join('/'), data);
    }
    save(data): ng.IHttpPromise<models.Negotiation>{
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations'].join('/'), data);
    }
    saveNotAuthorized(data){
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'not_authorize'].join('/'), data);
    }
    acceptTerms(data){
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'accept_terms'].join('/'), data);
    }
    download(filters): ng.IHttpPromise<any>{
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'excel'].join('/'), {}, { params: filters });
    }
    send(data){
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'send_email'].join('/'), data);
    }
    getGranters(){
      return this.$http.get([this.proxifier(), 'finadai', 'granters', 'list'].join('/'));
    }
    findCredit(data){
      var config: IRequestIgnoreValidation = { ignoreBEValidation: true };
      return this.$http.post([this.proxifier(), 'finadai', 'credits', 'search'].join('/'), data, config);
    }
    generatePayments(data){
      var config: IRequestIgnoreValidation = { ignoreBEValidation: true };
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'create_payments'].join('/'), data, config);
    }
    authorize(negotiation_id): ng.IHttpPromise<models.Negotiation>{
      return this.$http.post([this.proxifier(), 'finadai','negotiations', 'authorize'].join('/'), { negotiation_id: negotiation_id });
    }
    changeNoteStatus(data){
      return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'note_status'].join('/'), data);
    }
  }
}